import React from 'react'

const Unauthorized = () => {
  return (
    <div className="unauthorized-container">
      <h1>403 - Unauthorized Access</h1>
      <p>Sorry, you don't have permission to view this page.</p>
    </div>
  )
}

export default Unauthorized